/** @jsxRuntime classic */
import { useDebouncedValue } from '@mantine/hooks';
import React from 'react';
import { useTransformEffect } from 'react-zoom-pan-pinch';

const ScaleContext = React.createContext<number | null>(null);

/**
 * A provider to hook into the current scale of the floor plan.
 * Needed for Popover to recalculate the position when zooming.
 * Maybe there's a better way to do it, but for now this gets the job done.
 */
export function ScaleProvider({ children }: { children: React.ReactNode }) {
  const [rawScale, setScale] = React.useState<number | null>(1);
  const [scale] = useDebouncedValue(rawScale, 30);
  useTransformEffect(({ state }) => setScale(state.scale));
  return (
    <ScaleContext.Provider value={scale}>{children}</ScaleContext.Provider>
  );
}

export function useScale() {
  const scale = React.useContext(ScaleContext);
  if (scale === null) {
    throw new Error('useScale must be used within a ScaleProvider');
  }
  return scale;
}
